import type { SVGProps } from 'react';

const IconWrapper = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      {props.children}
    </svg>
  );
};

export default IconWrapper;
